<template>
  <div class="trocaUsuario__conteiner">
    <!-- <div style="display: block"> -->
    <ResumoPerfil
      v-if="usuario && usuario.nome"
      :resumo="usuario"
      :origem="'TrocaUsuario'"
    />
  </div>
  <div v-if="planosVinculados" @click.prevent="togglePlano()" style="display: block">
    <div class="planosVinculados--toggle">
      <ChevronDown v-bind:class="{ rotate: togglePlanos }" :size="40" />
    </div>
  </div>
  <!-- </div> -->
  <PlanosVinculados
    v-if="togglePlanos && usuario.chaves"
    :listaChaves="usuario.chaves"
    :origem="'TrocaUsuario'"
    v-model:novoParticipante="novo_participante"
  />
</template>

<script>
import FirebaseHelper from "@/service/FirebaseHelper";
import ResumoPerfil from "./ResumoPerfil.vue";
import PlanosVinculados from "./PlanosVinculados.vue";
import Utils from "../../functions/geral/utilsFunctions.js";
import ChevronDown from "vue-material-design-icons/ChevronDown.vue";
import { mapGetters, mapActions } from "vuex";

class PerfilUsuario {
  constructor() {
    this.apelido = "";
    this.nome = "";
    this.email = "";
    this.plano = "";
    this.chave = "";
    this.avatar = "";
    this.chaves = [];
    this.perfilIdade = "";
    this.sexo = "";
    this.nascimento = "";
    this.parentesco = "";
    this.cpf = "";
  }
}

export default {
  components: {
    ResumoPerfil,
    PlanosVinculados,
    ChevronDown,
  },
  data() {
    return {
      novo_participante: "",
      slides: 7,
      response: [],
      usuario: new PerfilUsuario(),
      firebaseHelper: new FirebaseHelper(),
      beneficiario: null,
      indexChaves: null,
      togglePlanos: false,
      loaded: false,
      planosVinculados: false,
    };
  },
  computed: {
    ...mapGetters({
      listaChaves: "listaChaves",
      login: "login",
      chave: "chave",
      cpf: "cpf",
      uid: "uid",
      participante: "participante",
      novaChave: "novaChave",
      isRP: "isRP",
    }),
  },
  watch: {
    novo_participante(val) {
      this.trocarUsuario(val);
    },
  },
  async mounted() {
    await this.getParticipacoes(this.cpf, this.uid);
  },
  methods: {
    ...mapActions([
      "atualizarEstadoAvatar",
      "atualizarEstadoChave",
      "atualizarEstadoNovaChave",
      "atualizarEstadoListaChaves",
    ]),
    togglePlano() {
      this.togglePlanos = !this.togglePlanos;
      this.loaded = true;
    },
    montarListaChaves() {
      this.usuario = new PerfilUsuario();
      this.planosVinculados = false;
      console.log("this.listaChaves", this.listaChaves);
      console.log("this.chave", this.chave);
      if (this.listaChaves.length > 0) {
        let usuario = this.listaChaves.find((usr) => usr.chave === this.chave);
        if (usuario) {
          this.usuario.nascimento = usuario.dtnasc;
          this.usuario.perfilIdade = Utils.perfilIdade(this.usuario.nascimento);
          this.usuario.sexo =
            usuario.sexo || this.participante.data.cadastro.informacoes_pessoais.sexo;
          this.usuario.nome = usuario.nome;
          this.usuario.avatar = usuario.avatar;
          this.atualizarEstadoAvatar(this.usuario.avatar);
          if (!this.usuario.avatar) {
            this.usuario.avatar = "avatarGenerico";
          }
          this.usuario.incluirFoto = this.usuario.avatar.includes("https://");
          (this.usuario.plano = usuario.plano), (this.usuario.chave = usuario.chave);
          this.usuario.email = usuario.email;
        }
        for (var i = 0; i < this.listaChaves.length; i++) {
          if (
            this.listaChaves[i].chave !== "RP-0" &&
            this.listaChaves[i].chave !== this.chave
          ) {
            this.planosVinculados = true;
            let chave = new PerfilUsuario();
            (chave.nome = this.listaChaves[i].nome),
              (chave.avatar = this.listaChaves[i].avatar || "avatarGenerico"),
              (chave.plano = this.listaChaves[i].plano),
              (chave.chave = this.listaChaves[i].chave),
              (chave.email = this.listaChaves[i].email),
              (chave.nascimento = this.listaChaves[i].dtnasc),
              (chave.sexo = this.listaChaves[i].sexo || "Masculino"), //avatar padrão será o masculino caso não identifique o sexo
              (chave.perfilIdade = Utils.perfilIdade(this.listaChaves[i].dtnasc));
            chave.parentesco = "";
            this.usuario.chaves.push(chave);
          }
        }
      }

      if (
        this.participante.data.cadastro &&
        this.participante.data.cadastro.beneficiarios
      ) {
        for (var j = 0; j < this.participante.data.cadastro.beneficiarios.length; j++) {
          let beneficiario = this.usuario.chaves.find(
            (chave) =>
              chave.nome.toUpperCase() ===
              this.participante.data.cadastro.beneficiarios[j].nome.toUpperCase()
          );
          if (!beneficiario) {
            this.planosVinculados = true;
            let chave = new PerfilUsuario();
            chave.apelido = this.participante.data.cadastro.beneficiarios[j].apelido
              ? this.participante.data.cadastro.beneficiarios[j].apelido
              : this.participante.data.cadastro.beneficiarios[j].nome;
            chave.nome = this.participante.data.cadastro.beneficiarios[j].nome;
            chave.avatar =
              this.participante.data.cadastro.beneficiarios[j].img || "avatarGenerico";
            chave.nascimento = this.participante.data.cadastro.beneficiarios[
              j
            ].nascimento;
            chave.plano = this.participante.data.cadastro.beneficiarios[j].plano;
            chave.chave = this.participante.data.cadastro.beneficiarios[j].chave;
            (chave.sexo = this.participante.data.cadastro.beneficiarios[j].sexo), //avatar padrão será o masculino caso não identifique o sexo
              (chave.perfilIdade = Utils.perfilIdade(
                this.participante.data.cadastro.beneficiarios[j].nascimento
              ));
            chave.parentesco = this.participante.data.cadastro.beneficiarios[
              j
            ].grau_parentesco;
            this.usuario.chaves.push(chave);
          }
        }
      }
    },
    async getParticipacoes(cpf, uid) {
      let listaChaves = await this.firebaseHelper.getParticipacoes(cpf, uid);
      this.atualizarEstadoListaChaves(listaChaves);
      this.montarListaChaves();
    },
    trocarUsuario(item) {
      if (item.chave) {
        this.togglePlanos = false;
        this.loaded = false;
        this.getParticipacoes(this.cpf, this.auth.currentUser.uid).then(() => {
          if (!item.cpf) item.cpf = this.cpf;
        });
        //this.atualizarEstadoChave(item.chave);
        this.atualizarEstadoNovaChave(item.chave);
      } else {
        if (item.nascimento.includes("/")) {
          let dataaux = item.nascimento.split("/");
          item.nascimento = new Date(
            dataaux[2],
            Number(dataaux[1]) - 1,
            dataaux[0]
          ).toString();
        }
        let dtnasc = new Date(item.nascimento);
        item.nascimento = Utils.dateFormat(dtnasc, false, false, true, false, false);
        let idade = this.idade(dtnasc, new Date());
        item.idade = idade;
        console.log("trocarUsuario >>>>>>>>>>> item", JSON.stringify(item, null, 2));
        if (idade < 18 && item.parentesco === "Filho(a)") {
          this.$router.push({
            path: "/adesaomenoridade",
            query: { beneficiario: JSON.stringify(item) },
          });
        } else {
          this.$router.push({
            path: "/adesaomaioridade",
            query: { beneficiario: JSON.stringify(item) },
          });
        }
      }
    },
    idade(nascimento, hoje) {
      var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
      if (
        new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
        new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())
      ) {
        diferencaAnos--;
      }
      return diferencaAnos;
    },
    dataFormatadaDDMMYYYY(data) {
      let dia = data.getDate().toString(),
        diaF = dia.length == 1 ? "0" + dia : dia,
        mes = (data.getMonth() + 1).toString(),
        mesF = mes.length == 1 ? "0" + mes : mes,
        anoF = data.getFullYear();
      return diaF + "/" + mesF + "/" + anoF;
    },
  },
};
</script>

<style scoped>
.div-conteiner-resumo-perfil {
  width: 100%;
  display: flex;
  justify-content: center;
}

.box-image--acessoRapido {
  border-radius: 8px;
  height: 60px;
  width: 60px;
  margin-left: 5px;
  margin-right: 5px;
  opacity: 1;
  background-color: #4b99ff;
  border-radius: 50px;
}

.p--planoVinculados {
  margin: 0 0 -8px 0;
  font-size: 12px;
}

.planosVinculados--toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.slide__img--acessoRapido {
  height: 70px;
  padding: 10px;
  margin-left: 4px;
  transition: 0.5s ease;
  backface-visibility: hidden;
  object-fit: cover;
}

.box-image--acessoRapido:hover .slide__img--acessoRapido {
  opacity: 0.3;
}

.p--slide {
  font-size: 10px;
  line-height: 15px;
  margin-top: 5px;
  text-align: center;
}

.trocaUsuario__conteiner {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: 10px;
}
</style>
